import React, { Component } from 'react';
import { Modal, Button, Row } from 'antd/lib';
import _ from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';

class ModalVerPedido extends Component {
  render() {
    let pedido = this.props.pedido;

    if (pedido._id) {
      return (
        <div>
          <Modal
            title={'Detalles del Pedido N°' + pedido.numero}
            visible={this.props.mostrarModalVerPedido}
            onCancel={this.props.ocultarModalPedido}
            width={500}
            footer={[
              <Button
                key="back"
                type="primary"
                onClick={this.props.ocultarModalPedido}
              >
                Volver
              </Button>,
            ]}
          >
            <Row>
              <h3> Organismo: {pedido.organismo.nombre} </h3>
              <h3>
                Fecha del Pedido:
                {moment(pedido.fechaPedido).format('DD/MM/YYYY')}
              </h3>
              <h4> Tasas Solicitadas: </h4>
              {_.map(pedido.detalle, det => (
                <p key={det.tipo_sello._id}>
                  {det.tipo_sello.nombre}: {det.cantidad} unidades.
                </p>
              ))}
            </Row>
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withApollo(ModalVerPedido);
